import { Hero } from "../components/home/Hero";
import { CommercialRoute } from "../components/home/CommercialRoute";
import { Marquee } from "../components/home/Marquee";
import { Method } from "../components/home/Method";
import { OperationalIntel } from "../components/home/OperationalIntel";
import { BuiltAtTitan } from "../components/home/BuiltAtTitan";
import { ActiveDevelopment } from "../components/home/ActiveDevelopment";
import { ResearchBehind } from "../components/home/ResearchBehind";
import { OperatingAreas } from "../components/home/OperatingAreas";
import { Evidence } from "../components/home/Evidence";
import { LatestNews } from "../components/home/LatestNews";
import { InquiryRouting } from "../components/home/InquiryRouting";
import { IntroReveal } from "../components/IntroReveal";
import { usePageMeta } from "../hooks/usePageMeta";

export default function HomePage() {
    usePageMeta(
        "Titan Haven Group LLC — We Build What the Problem Requires",
        "Titan Haven Group LLC builds and operates software, emerging technology, consumer businesses, digital assets, and media/IP. Observe. Question. Synthesize. Act.",
    );
    return (
        <main>
            <IntroReveal />
            <Hero />
            <CommercialRoute />
            <Marquee />
            <Method />
            <OperationalIntel />
            <BuiltAtTitan />
            <ActiveDevelopment />
            <ResearchBehind />
            <OperatingAreas />
            <Evidence />
            <LatestNews />
            <InquiryRouting />
        </main>
    );
}
